/* Visar korrekt bräde */
import React from "react";

import Twelve from './Boards/Twelve';
import Eleven from './Boards/Eleven';
import Ten from './Boards/Ten';
import Nine from './Boards/Nine';
import Eight from './Boards/Eight';
import Seven from './Boards/Seven';
import Six from './Boards/Six';

class Boards extends React.Component {
    static names =
    {
        6: "Sexan",
        7: "Sjuan",
        8: "Åttan",
        9: "Nian",
        10: "Tian",
        11: "Elvan",
        12: "Tolvan"
    };

    render() {
        return (
            <>
                {this.props.gameController.state.cg.boardsize === 6 ? <Six gameController={this.props.gameController} /> : ""}
                {this.props.gameController.state.cg.boardsize === 7 ? <Seven gameController={this.props.gameController} /> : ""}
                {this.props.gameController.state.cg.boardsize === 8 ? <Eight gameController={this.props.gameController} /> : ""}
                {this.props.gameController.state.cg.boardsize === 9 ? <Nine gameController={this.props.gameController} /> : ""}
                {this.props.gameController.state.cg.boardsize === 10 ? <Ten gameController={this.props.gameController} /> : ""}
                {this.props.gameController.state.cg.boardsize === 11 ? <Eleven gameController={this.props.gameController} /> : ""}
                {this.props.gameController.state.cg.boardsize === 12 ? <Twelve gameController={this.props.gameController} /> : ""}
            </>
        );
    }
}

export default Boards;
